<style src="./Button.scss" lang="scss"></style>

<template lang="pug">
  component.button(
    :is='tag'
    :class='classList'
    :type='type'
    :for='target'
    :to='href'
    :disabled='disabled'
    @click='$emit("click")'
  )
    slot {{ label }}
</template>

<script>
export default {
  props: {
    type: String,
    label: String,
    target: String,
    href: String,
    disabled: Boolean,
    classList: String
  },
  computed: {
    tag() {
      if (this.href) {
        return "router-link";
      }

      if (this.target) {
        return "label";
      }

      return "button";
    }
  }
};
</script>
